import type { DespesaExtratoComprovanteItem } from "../../../services/FinanceiroService";
import type { ComprovantesSindicatoRow } from "./comprovantesSindicatoTypes";
import {
  normalizeSituacaoComprovanteSindicato,
  onlyDigits,
  pickComprovantesListDates,
  pickSituacaoComprovanteNome,
  resolveEnvioComprovantesHabilitado,
} from "./comprovantesSindicatoUtils";

const resolveExtratoId = (item: Record<string, unknown>): number | null => {
  const id =
    (item.extratoId as number | undefined) ??
    (item.ExtratoId as number | undefined) ??
    (item.solicitacaoId as number | undefined) ??
    (item.idSolicitacaoAvaliacao as number | undefined) ??
    null;
  return typeof id === "number" && id > 0 ? id : null;
};

const resolveIdSindicato = (item: Record<string, unknown>): number | null => {
  const id =
    (item.sindicatoId as number | undefined) ??
    (item.idSindicato as number | undefined) ??
    (item.IdSindicato as number | undefined) ??
    null;
  return typeof id === "number" && id > 0 ? id : null;
};

/** Lista comprovantes (legacy ou solicitacoes) → linhas da visão Sindicato. */
export const mapSolicitacoesToComprovantesSindicatoRows = (
  comprovantes: DespesaExtratoComprovanteItem[] | unknown[],
  ano: number,
  sindicatoCnpj?: string | null,
): ComprovantesSindicatoRow[] => {
  const cnpjFiltro = onlyDigits(sindicatoCnpj);

  return (comprovantes || [])
    .filter((raw) => {
      if (!cnpjFiltro) return true;
      const item = (raw ?? {}) as Record<string, unknown>;
      return onlyDigits(item?.cnpj as string) === cnpjFiltro;
    })
    .map((raw, index) => {
      const item = (raw ?? {}) as Record<string, unknown>;
      const extratoId = resolveExtratoId(item);
      const idSindicato = resolveIdSindicato(item);
      const situacaoNome = pickSituacaoComprovanteNome(item);
      const situacao = normalizeSituacaoComprovanteSindicato(
        situacaoNome || "-",
      );
      const datas = pickComprovantesListDates(item);

      return {
        id: idSindicato ?? extratoId ?? index + 1,
        cnpj: (item.cnpj as string | undefined) ?? null,
        sigla: (item.sigla as string | undefined) ?? null,
        solicitacao: String(item.solicitacao || "—"),
        situacao,
        envio: datas.envio,
        solicitacaoCorrecao: datas.solicitacaoCorrecao,
        correcao: datas.correcao,
        envioFormulario: datas.envioFormulario,
        idSindicato,
        solicitacaoId: extratoId,
        extratoId,
        ano,
        envioHabilitado: resolveEnvioComprovantesHabilitado(item, situacao),
        bloqueado: item.bloqueado === true,
        historicoHabilitado: !!(idSindicato || extratoId),
        rowKey: `comp-sind-${extratoId ?? idSindicato ?? index}-${ano}`,
      };
    })
    .sort((a, b) => Number(a.extratoId ?? 0) - Number(b.extratoId ?? 0));
};

/**
 * @deprecated Prefer mapSolicitacoesToComprovantesSindicatoRows com resposta legacy.
 * Mantido para testes legados de um único sindicato.
 */
export const mapSindicatoLegacyToComprovantesSindicatoRow = (
  sindicato: Record<string, unknown> | null | undefined,
  ano: number,
): ComprovantesSindicatoRow[] => {
  if (!sindicato) return [];
  return mapSolicitacoesToComprovantesSindicatoRows([sindicato], ano);
};
